import React, { useEffect, useState } from "react";
import logo from '../components/invertible_logo.drawio.png';
import BSFZ_logo from '../components/BSFZ_seal.png';
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import "../css/navbar.css";
import { useAuth } from "../pages/AuthContext";
import { createPortal } from "react-dom";
import Navstrip from "../components/Navstrip";
import { Tooltip } from "@mui/material";

function Navbar() {
  const { user, org, logout,role } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isTrialOrg, setIsTrialOrg] = useState(true);

  const isLoginRoute = location.pathname === "/";
  console.log("userSessionRefNavbar:1",role)

  const handleLogout = () => {
    logout();
    //logout() is dependent on this localStorage variable.Do not delete first.
    localStorage.clear();
    navigate("/");
  };

  // Clean username
  let userName = "";
  if (user) {
    userName = user.trim().replace(/^"+|"+$/g, "");
  }

  const shortUser =
    userName.length > 0
      ? userName
          .split(" ")
          .map((w) => w[0])
          .join("")
          .toUpperCase()
          .slice(0, 2)
      : "";
  console.log("userSessionRefNavbar:2")
  // ✅ SAFE OUTSIDE CLICK HANDLER
  useEffect(() => {
    if (!showUserMenu) return;

    const handleClickOutside = () => {
      setShowUserMenu(false);
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [showUserMenu]);
  console.log("userSessionRefNavbar:3")

  const showSignIn =
    location.pathname === "/docs" ||
    location.pathname === "/contactForm" ||
    location.pathname === "/pricing";

  return (

    <div className="navbar">
      {/* LEFT SIDE */}
      <div className="navbar-left">
      <img
      src={logo}
      alt="Invertible Logo"
      className="invertible-logo"
      loading="lazy"
      />
       <div>
      {!user ? (
        <NavLink to="/" className="navbar-brand">
          Invertible
        </NavLink>
      ) : (
        <span className="navbar-brand">
          Invertible
        </span>
      )}
    </div>
    
      </div>


  <Tooltip
  arrow
  placement="bottom"
  slotProps={{
    tooltip: {
      sx: {
        backgroundColor: "#ffffff",
        color: "#1a1a1a",
        fontSize: "13px",
        lineHeight: 1.5,
        maxWidth: 340,
        padding: "12px 14px",
        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
        border: "1px solid #e0e0e0",
      },
    },
    arrow: {
      sx: {
        color: "#ffffff",
      },
    },
  }}
  title={
    <div style={{ maxWidth: "320px", lineHeight: 1.5 }}>
      <strong>BSFZ Recognised R&amp;D Organisation</strong>
      <br />
      Recognised under Germany's Research Allowance Act for eligible
      research and development activities.
      <br /><br />
      <strong>Recognised project:</strong> EdgeAnalytics — development of an AI-assisted, function-driven edge analytics application for local processing of machine, camera and process data, with signal extraction and rapid deployment.
    </div>
  }
  >

  {/* BSFZ Recognition Badge */}
<div className="bsfz-badge">  
  <img
    src={BSFZ_logo}
    alt="BSFZ Recognised R&D Organisation"
    className="bsfz-logo"
  />

  <div className="bsfz-text">
    <span className="bsfz-title">
    BSFZ Recognised R&amp;D Organisation
    </span>
    <span className="bsfz-subtitle">
      
    </span>
  </div>
</div>
</Tooltip>

<div
  className={"navbar-buttons"}
>
  {/* Public */}
  {!user && (
    <>
      {showSignIn && <NavLink to="/">Home</NavLink>}
      <NavLink to="/pricing">Pricing</NavLink>
      <NavLink to="/docs">Documentation</NavLink>
      <NavLink to="/contactForm">Contact Form</NavLink>
    </>
  )}

  {/* Individual User */}
  {user &&
  (role === "INDIVIDUAL_USER" ||
    role?.toLowerCase() === "functions_subscriber") && (
    <>
      <NavLink to="/listOfFiles">Files</NavLink>
      <NavLink to="/functions">Functions</NavLink>
      <NavLink to="/applyFunctions">Apply Functions</NavLink>
    </>
  )}

{user &&
  role !== "INDIVIDUAL_USER" &&
  role?.toLowerCase() !== "functions_subscriber" && (
    <>
      <NavLink to="/listConnectionPage">Configs</NavLink>
      <NavLink to="/listOfFiles">Files</NavLink>
      <NavLink to="/queryEditor">Query Editor</NavLink>
      <NavLink to="/functions">Functions</NavLink>
      <NavLink to="/applyFunctions">Apply Functions</NavLink>
      <NavLink to="/users">Users</NavLink>
      <NavLink to="/builds">Builds</NavLink>
    </>
  )}
</div>



      {/* USER MENU */}
      {!isLoginRoute && user && (
        <div className="user-menu-wrapper">
          {/* BUTTON */}
          <button
            className="user-menu-button"
            onClick={(e) => {
              e.stopPropagation(); // prevents immediate close
              setShowUserMenu((prev) => !prev);
            }}
          >
            <div className="user-avatar">{shortUser}</div>
            <span className="user-caret">
              {showUserMenu ? "▲" : "▼"}
            </span>
          </button>

          {showUserMenu &&
  createPortal(
    <div
      className="user-dropdown-card"
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "fixed",
        top: "64px",
        right: "20px",
        zIndex: 2147483647,
      }}
    >
      <div className="user-dropdown-header">
        <div>
          <div className="dropdown-username">{userName}</div>
          <div className="dropdown-org">{org}</div>
        </div>
      </div>

      <div className="dropdown-divider" />

      <NavLink to="/billing" className="dropdown-link">Billing</NavLink>
      <NavLink to="/docs" className="dropdown-link">Documentation</NavLink>
      <NavLink to="/contactForm" className="dropdown-link">Contact Form</NavLink>
      <NavLink to="/pricing" className="dropdown-link">Pricing</NavLink>

      <div className="dropdown-divider" />

      <button className="logout-btn" onClick={handleLogout}>
        Sign out
      </button>
    </div>,
    document.body
  )
} 
        </div>
      )}

    </div>
    
  );
}

export default Navbar;